export interface IEvent {
    identifier: string
    contextId: string
    date: any
    name: string
    active: boolean
    treibenCount: string
    huntingDistrictId: string
    huntingDistrictName: string
    updateTimestamp?: Date
}